import { Environments } from '@/config';
import { CONE_PRODUCTION } from './cone.production';
import { CONE_STAGING } from './cone.staging';

export const CONE = import.meta.env.MODE === Environments.PROD ? CONE_PRODUCTION : CONE_STAGING;
